import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  font-size: 13px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  border-radius: 4px;
`;

export const Settings = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;

  @media (max-width: 1200px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  .label {
    color: rgb(0 0 0 / 45%);
    font-size: 13px;
    white-space: nowrap;
  }

  .value {
    color: rgb(0 0 0 / 85%);
    font-size: 13px;
    white-space: nowrap;

    span {
      margin-left: 4px;
      color: rgb(0 0 0 / 45%);
      font-size: 12px;
      font-weight: 400;
    }
  }

  &:not(:last-child) {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      right: -12px;
      width: 1px;
      height: 12px;
      background: rgb(0 0 0 / 6%);

      @media (max-width: 1200px) {
        display: none; /* Hide separator on small screens when stacked */
      }
    }
  }
`;
